import React from 'react';
export function Hero() {
  return <section className="min-h-screen flex flex-col justify-center items-center text-center px-[5%] pt-[120px] pb-[80px] relative overflow-hidden z-10" data-id="element-25">
      {/* Glow orb background */}
      <div className="absolute w-[600px] h-[600px] rounded-full bg-[radial-gradient(circle,rgba(191,0,255,0.15)_0%,transparent_70%)] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none" data-id="element-26"></div>

      <div className="text-[0.75rem] tracking-[4px] uppercase text-neon-pink mb-5 px-[18px] py-[6px] inline-block relative z-10" data-id="element-27">
        ✦ Venado Tuerto · Santa Fe · Argentina ✦
      </div>

      {/* Logo Image with Cinematic Effect */}
      <div className="relative mb-8 flex justify-center items-center" data-id="element-28">
        <img src="https://cdn.magicpatterns.com/uploads/wzeecsvukFVufgdNEkpRrs/7.png" alt="Ganster Style Logo" className="w-64 md:w-80 lg:w-96 relative z-10 drop-shadow-[0_0_40px_rgba(255,45,120,0.8)] object-contain animate-[bounce-custom_4s_infinite]" data-id="element-29" />
      </div>

      <h1 className="font-bebas text-[clamp(3rem,9vw,7.5rem)] leading-[0.95] tracking-[2px] mb-7 relative z-10 flex flex-col items-center" data-id="element-30">
        <span data-id="element-31">ILUMINAMOS</span>
        <span className="text-gradient-pink-blue drop-shadow-[0_0_30px_rgba(255,45,120,0.5)]" data-id="element-32">
          TU MARCA
        </span>
        <span data-id="element-33">CON NEÓN</span>
      </h1>

      <p className="text-[clamp(1rem,2vw,1.25rem)] text-text-muted max-w-[540px] leading-[1.7] mb-11 relative z-10" data-id="element-34">
        Cuadros personalizados con luces neon que transforman cualquier espacio.
        Arte que brilla. Identidad que se ve de noche. Enviamos a todo el país
        con embalaje reforzado.
      </p>

      <div className="flex gap-4 flex-wrap justify-center relative z-10" data-id="element-35">
        <a href="https://wa.me/TUNUMEROACASIN549XXXXXXXXXX?text=Hola!%20Quiero%20pedir%20un%20presupuesto%20personalizado%20🔥" target="_blank" rel="noreferrer" className="bg-gradient-to-br from-neon-pink to-neon-purple text-white px-9 py-4 rounded-md font-bold text-[0.9rem] tracking-[1px] uppercase shadow-[0_0_30px_rgba(255,45,120,0.4)] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_0_50px_rgba(255,45,120,0.6)]" data-id="element-36">
          💬 Pedir Presupuesto Gratis
        </a>
        <a href="#productos" className="bg-transparent text-text-main px-9 py-4 rounded-md font-semibold text-[0.9rem] tracking-[1px] uppercase border border-dark-border transition-colors duration-300 hover:border-neon-pink hover:text-neon-pink" data-id="element-37">
          VER EJEMPLOS
        </a>
      </div>

      <div className="absolute bottom-9 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-text-muted text-[0.7rem] tracking-[2px] uppercase animate-bounce-slow" data-id="element-38">
        <div className="w-[1px] h-[40px] bg-gradient-to-b from-transparent to-neon-pink" data-id="element-39"></div>
        scroll
      </div>
    </section>;
}